(function () {

    "use strict";

    angular
        .module('components')
        .component('hSelectListAsync', {
            controller: HSelectListAsyncComponent,
            controllerAs: 'hSelectListAsync',
            bindings: {
                name: '@',
                hName: '@',
                textKey: '@',
                itemKey: '@',
                descriptionKey: '@',
                placeholder: '@',
                searchInitiallyVisible: '<',
                cssClass: '@',
                sortBy: '@',
                noClear: '<',
                noSearch: '<',
                ngDisabled: '<',
                showUserAvatar: '<',
                maxSelectedItemsCount: '<',
                showIcon: '@',
                arrowIcon: '@',
                allowInitItems: '<',
                hideSelectAll: '<',
                multi: '<',
                resultCallback: '&', // Must be a promise
                filterDebounce: '<',
                filterLabel: '<',
                ngChange: '&',
                ngModel: '<',
                itemTemplate: '<',
                isGrouped: '<',
                groupLabelClass: '@',
                isPaginated: '<',
                onReachBottom: '&',
            },
            templateUrl: '../hmodules/components/h-select-list-async/h-select-async.component.ng.html'
        });

    HSelectListAsyncComponent.$inject = ['$element', '$scope', '$timeout'];

    function HSelectListAsyncComponent($element, $scope, $timeout) {

        var self = this;
        self.$element = $element;

        self.$onInit = function () {
            self.name = self.name || self.hName;
            self.arrowIcon = self.arrowIcon || 'fa-chevron';
            self.isOpen = false;
            self.trigger = false;
            self.isAsync = true;
            self.noSearch = true;
            self.dataModel = angular.copy(self.ngModel);
            self.filterDebounce = self.filterDebounce || 0;
            fillInputValue();
            if (self.allowInitItems) {
                self.searchInputChanged(true);
            }
        };

        const fillInputValue = () => {
            let searchText = ''
            if (self.searchInitiallyVisible) {
                if (!self.multi) {
                    if (self.dataModel) {
                        searchText = self.dataModel[self.textKey] || '';
                    }
                } else {
                    if (self.dataModel?.length) {
                        searchText = '';
                        self.dataModel.forEach(function (item, index) {
                            if (item[self.textKey]) {
                                searchText += item[self.textKey];
                                if (index < self.dataModel.length - 1) {
                                    searchText += ', ';
                                }
                            }
                        });
                    }
                }
            }
            self.search = searchText || '';
        }

        self.$onChanges = function (changeObj) {
            if (
                changeObj.ngModel &&
                !changeObj.ngModel.isFirstChange() &&
                JSON.stringify(changeObj.ngModel.currentValue) !== JSON.stringify(changeObj.ngModel.previousValue)
            ) {
                self.dataModel = angular.copy(changeObj.ngModel.currentValue);
                self.trigger = !self.trigger;
            }
        };

        self.onListAsyncReachBottom = async (event) => {
            try {
                const promise = self.onReachBottom({
                    'loadPromise': event,
                    'search': self.search
                }) || event['promise'];
                self.items = await promise;
            } catch (err) {
                console.error(err);
            }
        };

        self.onModelChanged = function (items) {
            if (!self.isPaginated) {
                if (self.filterLabel || self.filterLabel === '') {
                    self.search = self.filterLabel;
                } else if (items && items.length) {
                    self.search = items[0][self.textKey];
                }
            }

            self.ngChange({items: self.multi ? self.dataModel : [self.dataModel]});
        };

        self.openList = function () {
            if (self.items && self.items.length) {
                self.isOpen = false;
                setTimeout(function () {
                    self.isOpen = true;
                    $scope.$digest();
                }, 100);
            }
        };

        self.closeList = () => {
            self.isOpen = false;
        };

        self.onOpenStateChange = function (isOpen) {
            self.isOpen = isOpen;
        };

        self.searchInputChanged = function (forceClose) {
            self.isSearching = true;

            var onEvent = function (event) {
                switch (event) {
                    case 'start':
                        self.isLoading = true;
                        break;
                    case 'end':
                        self.isLoading = false;
                        self.isSearching = false;
                        break;
                }

                $scope.$evalAsync();
            };

            var $event = {value: self.search, on: onEvent};

            var returnMap = {};
            var promise = self.resultCallback({$event: $event, returnMap: returnMap}) || returnMap['promise'];

            promise
                .then(function (items) {
                    self.items = items;

                    if (forceClose) {
                        self.isOpen = false;
                    } else {
                        self.isOpen = true;
                    }
                    $scope.$evalAsync();
                }, function (error) {
                    if (error && error.code !== 'MIN_LENGTH') {
                        hAlert(
                            'Something went wrong with fetching new items',
                            JSON.stringify(error, null, "   "),
                            function () {
                                self.items = [];
                                $scope.$evalAsync();
                            },
                            'h-general-error-alert'
                        );
                    } else {
                        self.items = [];
                        $scope.$evalAsync();
                    }
                });
        };
    }

})();
